"use client";

import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import dynamic from 'next/dynamic';
import footerData from "@/data/static-footer-data.json";
import Footer from "@organisms/Footer";
import {programsData} from "@/data/static-programs-data";
import ProgramList from '@/components/organisms/SimilarProgramsSection/ProgramList';
import { associatedPrograms } from '../(primary)/mba-campus-immersion-online/pageJSON';
import headerListMenu from '@/data/program-menu-data.json'

const HeaderOpt = dynamic(() => import("@/components/organisms/HeaderOpt"));

export default function GlobalError({ error, reset }: { error: Error; reset: () => void }) {
  const router = useRouter();

  useEffect(() => {
    console.error('Client error:', error);
  }, [error, router]);

  return (
    <>
        <HeaderOpt popularCourses={[]} newLaunches={[]} isMobile={false} associatedPrograms={associatedPrograms} headerMenuList={headerListMenu}/>
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <h1>An unexpected error occurred. We’re investigating and will fix it shortly.</h1>
          <p> </p>
          <a href="/" style={{color : "blue"}}>Go to Home</a>
        </div>
        <div className='pl=[6.25rem] pr=[6.25rem] max-w-[85%] m-auto'>
        <ProgramList programs={programsData} />
        </div>
      <Footer footerData={footerData} />
    </>
  );
}
